const EDIT_FORM = { formname: 'edit-agent-form' };

const agentStore = (apiServices => ({
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    agent: {},
    crm: null,
    files: [],
  },
  mutations: {
    setAgent: (state, agentObj) => {
      state.agent = agentObj; // eslint-disable-line no-param-reassign
    },
    setAgentCRM: (state, crm) => { // eslint-disable-line no-param-reassign
      state.crm = crm; // eslint-disable-line no-param-reassign
    },
  },
  actions: {
    async loadAgentCRM(context, payload) {
      const param = {
        agentId: payload.agentId ? payload.agentId : null,
        prospectorserviceid: payload.prospectorserviceid ? payload.prospectorserviceid : null,
      };

      return apiServices.pp.crmProvider.getAll(null, param)
        .then((crm) => {
          if (crm.length > 0) {
            crm = crm[0];
          } else {
            crm = null;
          }
          context.commit('setAgentCRM', crm);
        });
    },
    async loadAgent(context, agentKey) {
      return apiServices.oa.agent.getByKey(agentKey)
        .then((agentData) => {
          context.commit('setAgent', agentData);
        });
    },
    async getFilesByAgentKey(context, payload) {
      return apiServices.oa.agent.getFilesByAgentKey(payload.agentId, payload.leadId)
        .then((files) => {

        });
    },
    async updateAgent(context, payload) {
      return apiServices.oa.agent.update(Object.assign({}, EDIT_FORM, payload.data))
        .then((agentData) => {
          context.commit('setAgent', agentData);
        });
    },
  },
  getters: {
    hasCRMIntegration: state => state.crm !== null,
  },
}));

export default agentStore;
